import { render, staticRenderFns } from "./OrderUpdateProducts.vue?vue&type=template&id=017c48e6"
import script from "./OrderUpdateProducts.vue?vue&type=script&lang=js"
export * from "./OrderUpdateProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports